import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { AuthLayout } from '@/components/layout/auth-layout';
import { apiClient } from '@/lib/api-client';

function extractApiMessage(err: unknown, fallback: string): string {
  const body = (err as { body?: unknown })?.body;
  const raw = (body as { message?: unknown })?.message;
  if (typeof raw === 'string') return raw;
  return (err as Error)?.message ?? fallback;
}

export default function ResetPasswordPage() {
  const { token = '' } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (password !== confirm) {
      setError('As senhas não coincidem');
      return;
    }
    setLoading(true);
    try {
      await apiClient.confirmPasswordReset(token, password);
      navigate('/sign-in?msg=password-reset-ok', { replace: true });
    } catch (err) {
      setError(extractApiMessage(err, 'Token inválido ou expirado'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthLayout>
      <Card>
        <CardHeader>
          <CardTitle>Definir nova senha</CardTitle>
          <CardDescription>
            Escolha uma senha forte (12+ caracteres).
          </CardDescription>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="password">Nova senha</Label>
              <Input
                id="password"
                type="password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={12}
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="confirm">Confirme a nova senha</Label>
              <Input
                id="confirm"
                type="password"
                autoComplete="new-password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                minLength={12}
              />
            </div>
            {error && (
              <p className="text-sm text-red-600" role="alert">
                {error}
              </p>
            )}
          </CardContent>
          <CardFooter className="flex-col gap-3">
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar nova senha'}
            </Button>
            <Link
              to="/sign-in"
              className="text-sm text-[var(--fg-muted)] hover:underline"
            >
              Voltar para o login
            </Link>
          </CardFooter>
        </form>
      </Card>
    </AuthLayout>
  );
}
